import { ApiGender } from '@ibe/api';
import { ConfigModel } from '@ibe/services';
import { displayFormatDate, displayFormatDateTime } from './displayFormats';

export const customConfig: Partial<ConfigModel> = {
  defaultLanguage: 'de',
  defaultCurrency: '',
  apiUrl: '/api',
  configUrl: '/config.json',

  displayFormatDate,
  displayFormatDateTime,

  googleTagManagerContainerId: 'GTM-N6HPL4S',

  traveler: {
    genderValues: [ApiGender.MALE, ApiGender.FEMALE],
    maxChildAge: 17,
    maxInfantAge: 1,
    mockAvailable: false
  },

  session: {
    expirationTimeNotificationOffset: 5
  },

  sessionKeySearchParams: 'iso__best-price-availability-detail-url',
  outsideElementsContainerId: 'iso',
  useIndexedGeoUnits: true
};

export const accountingAreaHeaderName = 'Accounting-Area';
